import React from 'react';
import { Route} from 'react-router-dom';

import {PaginaInicial, GerenciarOS, FormSalvarPedido, GerenciarPedidos, GerenciarServico, FormSalvarOS, TermosOS} from '../paginas';

import {Divider, Menu} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGlasses,faTachometerAltFast, faBagsShopping, faPlus, faTools, faClipboardList } from '@fortawesome/pro-light-svg-icons'
import { Link } from 'react-router-dom';
import { useAuth } from '../hooks';
import { faSignOut } from '@fortawesome/pro-duotone-svg-icons';

 const {SubMenu} = Menu;


const MainMenu = ({callbackSelect}) => {
    const pathname = window.location.pathname;
    const auth = useAuth();
    const onClickHandle = (evt) => {
        callbackSelect && callbackSelect(evt);
    }

    const onLogoutHandle = evt => {
        auth.signOut();
    }
    
    return (<Menu 
        mode='inline'
        defaultSelectedKeys={[pathname]} >

            <Menu.Item key='/' onClick={onClickHandle} icon={<FontAwesomeIcon icon={faTachometerAltFast} /> }><Link to="/">Dashboard</Link></Menu.Item>                  
            <SubMenu key="pedidos" title="Pedidos" icon={<FontAwesomeIcon icon={faBagsShopping} />}>

                <Menu.Item key='/pedidos' onClick={onClickHandle} icon={<FontAwesomeIcon icon={faBagsShopping} /> }><Link to="/pedidos">Gerenciar Pedidos</Link></Menu.Item>                  
                <Menu.Item key='/pedidos/novo' onClick={onClickHandle} icon={<FontAwesomeIcon icon={faPlus} /> }> <Link to="/pedidos/novo">Novo Pedido</Link></Menu.Item>    

            </SubMenu>
            
            <SubMenu key="servicos" title="Ordem de Serviços" icon={<FontAwesomeIcon icon={faTools} />} >
                <Menu.Item key='/os/gerenciar' onClick={onClickHandle} icon={<FontAwesomeIcon icon={faTools} /> }> <Link to="/os/gerenciar">Gerenciar OS</Link></Menu.Item>              
                <Menu.Item key='/os/nova' onClick={onClickHandle} icon={<FontAwesomeIcon icon={faPlus} /> }> <Link to="/os/nova">Nova Ordem de Serviço</Link></Menu.Item>              
                <Menu.Item key='/servico/gerenciar' onClick={onClickHandle} icon={<FontAwesomeIcon icon={faClipboardList} /> }> <Link to="/servico/gerenciar">Catálogo de Serviços</Link></Menu.Item>
                <Menu.Item key='/os/termos' onClick={onClickHandle} icon={<FontAwesomeIcon icon={faGlasses} /> }> <Link to="/os/termos">Termos da OS</Link></Menu.Item>
            </SubMenu>
            <Divider></Divider>
            <Menu.Item key='/sair' onClick={onLogoutHandle} icon={<FontAwesomeIcon icon={faSignOut} /> }><Link to="#">Sair</Link></Menu.Item>                  

            {/* <SubMenu key="relatorios" title="Relatórios" icon={<FontAwesomeIcon icon={faCog} />}>
                <Menu.Item>Pedidos por Cidade</Menu.Item>
                <Menu.Item>Pedidos por Vendedor</Menu.Item>
            </SubMenu> */}
    </Menu>);
}



const getMainMenuRouter = () => {
    return ( <>
    <Route exact path="/" component={PaginaInicial}/>
    <Route exact path="/pedidos" component={GerenciarPedidos}/>
    <Route exact path="/pedidos/novo" component={FormSalvarPedido}/>
    <Route exact path="/pedido/:id" component={FormSalvarPedido}/>
    <Route exact path="/os/gerenciar" component={GerenciarOS}/>
    <Route exact path="/os/nova" component={FormSalvarOS}/>
    <Route exact path="/os/editar/:id" component={FormSalvarOS}/>
    <Route exact path="/os/termos" component={TermosOS}/>
    
    <Route exact path="/servico/gerenciar" component={GerenciarServico}/>
    
    </>);
}

export {MainMenu, getMainMenuRouter};